import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import { Link } from "react-router-dom"
import logoDark from "../../assets/images/diplomlogo.png"
import logoLightSm from "../../assets/images/skeleton-logo.png"
import logoDarkSm from "../../assets/images/logo.png"
import NewLogo from "../../assets/images/new_logo.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoDarkSm} alt="" height={30} />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" style={{ width: "200px" }} />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSm} alt="" height={30} style={{ objectFit: "contain", paddingTop: "20px", }} />
            </span>
            <span className="logo-lg">
              <img src={NewLogo} alt="" style={{ width: "180px", objectFit: "contain", paddingTop: "20px", }} />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
